
import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'

/* eslint-disable */

Vue.use(Vuex)
var config = {
  apiKey: "AIzaSyD5EyZ3Rb0WRGz9LVhgNYDN41Ty0deE33g",
    authDomain: "demobo-1c473.firebaseapp.com",
    databaseURL: "https://demobo-1c473.firebaseio.com",
    projectId: "demobo-1c473",
    storageBucket: "demobo-1c473.appspot.com",
    messagingSenderId: "608624263082"
};
firebase.initializeApp(config);

export default new Vuex.Store({

  state: {
    loadedMeetups: [
      {
        imageUrl: 'https://www.androidcentral.com/sites/androidcentral.com/files/styles/xlarge/public/article_images/2018/06/days%20gone%201.jpg?itok=Q3APWfFy',
        id: 'afajfjadfaadfa323',
        title: 'wow! new game!',
        date: new Date(),
        location: 'wow!',
        description: 'Aha wowow!'
      },
      {
        imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/7/7a/Paris_-_Blick_vom_gro%C3%9Fen_Triumphbogen.jpg',
        id: 'aadsfhbkhlk1241',
        title: 'i really hate this match......',
        date: new Date(),
        location: 'china',
        description: 'what the hell'
      }
    ],
    user: null,
    loading: false,
    error: null,
    articles: require('@/data/articles.json'),
    drawer: false,
   items: [
      {
        text: 'Home',
        href: '/'
      },
      {
        text: 'WriteNew',
        href: '/Discussion'
      },
      {
        text: 'Discussion',
        href: '/meetups'
      },
      {
        text: 'Video',
        href: '/videoPlayer'
      },
      {
        text: 'More?',
        href: '/searchpanel'
      },
      {
      text: 'Personal center',
      href: '/personalcenter'
      },
      {
        text: 'Where are you',
        href: '/outlook'
      }
    ],
  },

  mutations: {
    setLoadedMeetups (state, payload) {
      state.loadedMeetups = payload
    },
    createMeetup (state, payload) {
      state.loadedMeetups.push(payload)
    },
    setUser (state, payload) {
      state.user = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    setDrawer: (state, payload) => (state.drawer = payload),
    toggleDrawer: state => (state.drawer = !state.drawer)
  },
  actions: {
    loadMeetups ({commit}) {
      commit('setLoading', true)
      firebase.database().ref('meetups').once('value')
        .then((data) => {
          const meetups = []
          const obj = data.val()
          for (let key in obj) {
            meetups.push({
              id: key,
              title: obj[key].title,
              description: obj[key].description,
              imageUrl: obj[key].imageUrl,
              date: obj[key].date,
              creatorId: obj[key].creatorId
            })
          }
          commit('setLoadedMeetups', meetups)
          commit('setLoading', false)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', false)
          }
        )
    },
    autoSignIn ({commit}, payload) {
      commit('setUser', {id: payload.uid, registeredMeetups: []})
    },
    createMeetup ({commit, getters}, payload) {
      const meetup = {
        title: payload.title,
        Type: payload.Type,
        description: payload.description,
        date: payload.date.toISOString(),
        creatorId: getters.user.id
      }
      let imageUrl
      let key
      firebase.database().ref('meetups').push(meetup)
        .then((data) => {
          const key = data.key 
          return key
        })
        .then(key => {
        const filename = payload.image.name
        const ext = filename.slice(filename.lastIndexOf('.'))
        return firebase.storage().ref('meetups/' + key + '.' + ext).put(payload.image)
        })
        .then(fileData => {
        imageUrl = fileData.metadata.downloadURLs[0]
        return firebase.database().ref('meetups').child(key).update({imageUrl:imageUrl})
        })
        .then(() => {
            commit('createMeetup', {
            ...meetup,
            imageUrl: imageUrl,
            id: key
          })
        })
        .catch((error) => {
          console.log(error)
        })
      // Reach out to firebase and store it
    },
  },
  getters: {
    loadedMeetups (state) {
      return state.loadedMeetups.sort((meetupA, meetupB) => {
        return meetupA.date > meetupB.date
      })
    },
    featuredMeetups (state, getters) {
      return getters.loadedMeetups.slice(0, 5)
    },
    loadedMeetup (state) {
      return (meetupId) => {
        return state.loadedMeetups.find((meetup) => {
          return meetup.id === meetupId
        })
      }
    },
    user (state) {
      return state.user
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    categories: state => {
      const categories = []

      for (const article of state.articles) {
        if (
          !article.category ||
          categories.find(category => category.text === article.category)
        ) continue

        const text = article.category

        categories.push({
          text,
          to: `/category/${text}`
        })
      }

      return categories.sort().slice(0, 4)
    },
    links: (state) => {
      return state.items
    }
  },
  
})








